<template>
    <div class="app-screen-header" :class="onClassName" :style="headerStyle">
        <div class="t-flex">
            <div class="icon-be-back t-animated" @click="onBeBack">
                <span class="back-button" :style="buttonStyle"></span>{{onBeBackStateEcho}}
            </div>
            <div class="col-flex"><div class="t-clamp"><div class="content" v-html="onTitle"></div></div></div>
            <div class="right-button" v-show="onRightButton" @click="$emit('onRightButtonSend')">
                <slot name="right-button"></slot>
            </div>
            <div class="icon-be-back mirror" v-show="!onRightButton && onBeBackState && !isBeBackHide">
                <span class="back-button"></span>{{onBeBackStateEcho}}
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import Core from '@/until/core'
    export default {
        name: 'ScrollHeaderMenu',
        props: {
            onBeBackAuto: {
                type: [String, Boolean],
                default () {
                    return true
                }
            },
            onBeBackState: { // 是否显示返回按钮 , 但是否真正显示按钮会受 onBeBackAuto 影响
                type: [String, Boolean],
                default () {
                    return ''
                }
            },
            onBeBackNoticeState: {
                type: [String, Number],
                default () {
                    return 1
                }
            },
            onMenuHeight: {
                type: String,
                default () {
                    return '40px'
                }
            },
            onStyle: {
                type: [String, Object],
                default () {
                    return {}
                }
            },
            onTitle: {
                type: String,
                default () {
                    return ''
                }
            },
            onBackOptions: {
                type: [String, Object],
                default () {
                    return null
                }
            },
            onRightButton: {
                type: [String, Boolean],
                default () {
                    return false
                }
            },
            onClassName: {
                type: String,
                default () {
                    return ''
                }
            }
        },
        computed: {
            onBeBackStateEcho () {
                if (_.isString(this.onBeBackState)) {
                    return this.onBeBackState
                }
                return ''
            },
            headerStyle () {
                let style = Object.assign({}, _.isPlainObject(this.onStyle) ? this.onStyle : {})
                style.height = this.onMenuHeight
                style.lineHeight = this.onMenuHeight
                return style
            },
            buttonStyle () {
                return {
                    borderBottomColor: this.headerStyle.color,
                    borderLeftColor: this.headerStyle.color
                }
            },
            isBeBackHide () {
                return this.onBeBackAuto === true && this.onBeBackState && !Core.isBeBack()
            }
        },
        methods: {
            onBeBack () {
                const that = this
                const noticeState = parseInt(that.onBeBackNoticeState, 10) || 1
                if (noticeState === 1) {
                    if (_.isString(that.onBackOptions)) {
                        return that.$router.push({name: that.onBackOptions, params: that.$route.params, query: that.$route.query})
                    } else if (_.isPlainObject(that.onBackOptions)) {
                        return that.$router.push(that.onBackOptions)
                    }
                    that.$router.back(-1)
                } else if (noticeState === 2) {
                    return that.$emit('onBeBackNotice')
                }
            }
        }
    }
</script>
<style scoped="">
    .app-screen-header{ position: absolute; top: 0; right: 0; left: 0; height: 40px; line-height: 40px; text-align: center; background-color: rgba(255,255,255,1); z-index: 9; font-size: 18px; }
    .app-screen-header .icon-be-back{ position: relative; overflow: hidden; padding-right: 5px; padding-left: 30px; color: #333; font-size: 14px; }
    .app-screen-header .right-button{ position: relative; overflow: hidden; }
    .app-screen-header .icon-be-back.mirror{ opacity: 0; }
    .app-screen-header .icon-be-back .back-button{ position: absolute; top: 50%; left: 12px; content: ''; width: 12px; height: 12px; margin-top: -6px; border: 1px solid transparent; border-bottom-color: #333; border-left-color: #333; transform: rotate(45deg); }

    .app-screen-header.honour{ background-color: #0e0d08; }
    .app-screen-header .t-flex{ height: 100%; }
    .app-screen-header.honour .icon-be-back{ color: #fff; }
    .app-screen-header.honour .content{ color: #fff1de; }
    .app-screen-header.honour .icon-be-back .back-button{ border-bottom-color: #fff; border-left-color: #fff; }
</style>



// WEBPACK FOOTER //
// src/public/ScrollHeaderMenu.vue